(ns frontend.ux-overhaul.listing.fund-commitment.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.fund-commitment.event :as fund-commitment-event]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "fund-commitment-listing")

(defn- open-fund-commitment!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/fund-commitment})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/fund-commitment
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :fund-commitment
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-fund-commitment
                                 :label    (loc/tr :fund-commitment-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fund-commitment-event/create-fund-commitment]}
                                {:id                  :bulk-edit-fund-commitments
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::fund-commitment-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-fund-commitments
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::fund-commitment-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-fund-commitments
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fund-commitment-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-fund-commitments-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fund-commitment-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/fund-commitment})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :fund-commitments-grid)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.fund-commitment/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::fund-commitment-event/create-fund-commitment])
         :on-row-clicked           open-fund-commitment!
         :on-card-clicked          open-fund-commitment!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/fund-commitment}]
       [menu-actions/field-requirements-modal]])}))
